import {Button, Menu, message, Row, Spin, Tabs} from 'antd';
import React, {Component} from 'react';
import {connect} from "react-redux";
import "../../../asset/style/scanner/scanner.css";
import {get, post_response} from "../../../helper/request";
import {getDeviceStatus, setDeviceBusy, setDeviceIdle} from '../../../redux_actions/device_status.action';
import {
    dropDistanceConfirmed,
    receivedPreviewStatus,
    selectionCancelled,
    selectionConfirmed,
    selectionDone,
    setAutoThreshLevel,
    setDoTilingAfterScan,
    setDoTilingOnly,
    setDropDistancePointLength,
    setDropDistancePointOnly,
    setFocusPoints,
    setFolderName,
    setPreviewStatusToConfirmed,
    setScanName,
    setScanSpeed,
    setScanZLevels,
    setScanZStepSize,
    setSpecimenType,
    unsetDoTilingAfterScan,
    unsetDoTilingOnly,
    updateActionOngoing,
    updatePreviewStatus
} from '../../../redux_actions/preview_status.action';
import {RegionSelectionConstants} from "../../../redux_constants/region_selection.constant";
import {ScanApiConstant} from '../../../redux_constants/scan.constant';
import {
    brushShape,
    brushType,
    circleBrushSize,
    scanSettingsTypeVals,
    scanSpeed,
    scanTypeVals,
    scanWorkflowLoadingMessages,
    SlotRegionSelectionConstants,
    specimenType
} from "../../../utils/const";
import "../../../view/c240/c240_general_preview_area_selection.css";
import {
    boundRegions,
    cleanThresholdBorder,
    cleanUpExtra,
    createBorderOnThresholdedCanvas,
    drawCrossHairInitial,
    prepareThresholdImageForSave,
    updateImages
} from "../slot_component_utils";
import AdvancedPreviewSettingsComp from './c240_advanced_preview_settings_component';
import GeneralPreviewSettingsComp from './c240_general_preview_setting_component';

const {TabPane} = Tabs;

const initState = (id, previewStatus, initRegions) => ({
    regions: initRegions,
    selectedSlot: id,
    previewStatus: previewStatus,
    usingBrush: true,
    brushType: (previewStatus.response || {}).areaSelectionFinalized ? brushType.BRUSH : brushType.REDRAW,
    regionArea: 0,
    brushSize: 7,
    scan_type: previewStatus.numWBCToScan !== -1 ? scanTypeVals.BLOOD : previewStatus.speed === scanSpeed.ZSTACK ? scanTypeVals.Z_STACK : scanTypeVals.WSI,
    wbcCount: previewStatus.numWBCToScan,
    reading_barcode: false,
    overrideBlank: false,
    scanSettingsType: scanSettingsTypeVals.GENERAL,
    scanPathSet: false,
    currResponse: {},
    cacheBusterTime: (new Date()).getTime(),
    useDefaultMask: !(previewStatus.response || {}).areaSelectionFinalized,
    autoExport: false,
    brushShape: brushShape.SQUARE
})

// interface to mark area for scanning (also select scan speed and stain type)
class SlideAreaSelectionComponent extends Component {

    constructor(props) {
        super(props);

        let autoThresholdLevel = this.props.preview.response.threshLevelResult.goodDefaultIndex;
        if (typeof autoThresholdLevel !== "number") {
            autoThresholdLevel = 0;
        }
        this.state = {
            autoThresholdLevel: autoThresholdLevel
        }
        
        this.defaultRegion = [{
            height: 90,
            width: 100,
            x: 0,
            y: 5,
        }];

        let region = this.defaultRegion;

        region[0]['data'] = {index: 0}
        this.state = initState(this.props.id, this.props.preview, region);
        this.paint = false;

    }

    updateArea = (regionArea) => {
        this.setState({
            regionArea
        });
    }

    onCanvasUpdate = (regions) => {
        this.setState({
            regions: boundRegions(regions, false)
        });
        const [rack, tray] = this.getRackAndTray()
        const slideKey = `R${rack}T${tray}S${this.props.id}`
        const slot_status = (((this.props.deviceStatus[this.props.deviceId] || {}).scanner_health || {}).scanner_response || {}).slideLevelScanPreviewStatus[slideKey]
        let previewHeight = ((slot_status || {}).previewResponse || {}).previewHeight
        let previewWidth = ((slot_status || {}).previewResponse || {}).previewWidth
        // getAreaFromBoundingBox(regions[0], previewHeight, previewWidth, this.state.selectedSlot, this.props.deviceId, this.updateArea);
    }

    drawDropDistancePoint = (dropDistancePoint) => {
        drawCrossHairInitial(dropDistancePoint[0].x, dropDistancePoint[0].y, this.previewCanvas, {
            clearCanvas: true,
            size: 6,
            width: 2,
            color: '#EE4B2B'
        }, this.props.preview);
    }

    updateGreenBox = () => {
        let greenBoxRegion = [0, 0, 0, 0];
        let areaSelectionWasFinalized = (((this.props.preview || {}).response || {}).areaSelectionFinalized || false);

        if (areaSelectionWasFinalized && this.thresholdCanvas && !this.state.useDefaultMask) {
            let pW = this.thresholdCanvas.width;
            let pH = this.thresholdCanvas.height;

            greenBoxRegion = (((this.props.preview || {}).response || {}).greenBoxRegion);


            if (!greenBoxRegion || greenBoxRegion.length < 4) return;

            greenBoxRegion[0] = (100.0 * greenBoxRegion[0]) / pW;
            greenBoxRegion[2] = (100.0 * greenBoxRegion[2]) / pW - greenBoxRegion[0];
            greenBoxRegion[1] = (100.0 * greenBoxRegion[1]) / pH;
            greenBoxRegion[3] = (100.0 * greenBoxRegion[3]) / pH - greenBoxRegion[1];

            let regions = [{
                x: greenBoxRegion[0], y: greenBoxRegion[1], width: greenBoxRegion[2], height: greenBoxRegion[3],
                data: this.state.regions[0].data,
                isChanging: this.state.regions[0].isChanging,
                new: this.state.regions[0].new,
            }];

            this.setState({regions: []}, () => {
                this.setState({regions: regions}, () => {
                    this.onCanvasUpdate(this.state.regions);
                })
            })
        }
    }

    componentDidMount = () => {
        console.log(this.props)
        let newStatus = (this.props.preview || {}).status;

        //WBC or FIELDS
        if (this.props.preview && this.props.preview.numWBCToScan !== undefined) {
            this.setState({
                wbcCount: this.props.preview.numWBCToScan
            })
        }

        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.SELECTION_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        } else if (this.state.previewStatus !== newStatus && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.SELECTION_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let cache_buster_time = this.state.cacheBusterTime;
                let maskLocation = this.props.preview.response.maskLocation + "?d=" + cache_buster_time;
                let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
                if ((this.props.preview || {}).specimenType == specimenType.HNE_TISSUE) {
                    defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.IHC) {
                    defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.PAP) {
                    defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BM) {
                    defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
                }
                updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
                    this.thresholdCanvas, this.state.useDefaultMask ? defaultMaskLocation : maskLocation, this.state.regions, this.cleanupExtraCallback);
            }
            this.setState(Object.assign({}, this.state, {previewStatus: newStatus}));
        }
        this.selectFullRegion();
        this.onCanvasUpdate(this.state.regions);
    }

    componentDidUpdate(prevProps, prevState) {
        // TODO: Move this to componentDidMount and after change in drop-distance api callback
        this.drawDropDistancePoint(this.props.preview.response.dropDistancePoint);

        if (this.props.preview.response.threshLevelResult.goodDefaultIndex !== prevProps.preview.response.threshLevelResult.goodDefaultIndex) {
            this.setState({autoThresholdLevel: this.props.preview.response.threshLevelResult.goodDefaultIndex});
        }

        this.updatePreviewBox(prevState);

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.FETCHED_IMAGE) {
            this.selectFullRegion();
        }

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.START_DROP_DISTANCE_SELECTION) {
            if (this.props.preview.dropDistancePoint != undefined) {
                drawCrossHairInitial(this.props.preview.dropDistancePoint[0].x, this.props.preview.dropDistancePoint[0].y, this.dropDistanceCanvas,
                    {clearCanvas: true, color: 'red', size: 10, width: 1}, this.props.preview);
            }
        }

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.START_FOCUS_POINTS_SELECTION) {
            let pointDrawn = false;
            for (let island in this.props.preview.focusPoints) {
                for (let i = 0; i < this.props.preview.focusPoints[island].length; i++) {
                    let focusUnit = this.props.preview.focusPoints[island][i];
                    if (focusUnit.length > 0) {
                        drawCrossHairInitial(focusUnit[0].x, focusUnit[0].y, this.focusPointsCanvas,
                            {clearCanvas: !pointDrawn, color: 'green', size: 5, width: 1}, this.props.preview);
                        pointDrawn = true;
                    }
                }
            }
        }

        // const initialState = initState(this.props.id, this.props.preview, null)
        // const initialBrushSize = initialState.brushSize || 7
        // if (prevProps.brushType !== this.state.brushType &&
        //     this.state.brushType === brushType.ERASER &&
        //     this.state.brushSize <= initialBrushSize) {
        //     this.setState({ brushType: initialBrushSize * 2 })
        // }
    }

    updatePreviewBox = (prevState) => {
        let newStatus = (this.props.preview || {}).status;
        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.SELECTION_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        } else if ((this.state.previewStatus !== newStatus ||
            (this.state.brushType !== prevState.brushType &&
                !(prevState.brushType == brushType.BRUSH && this.state.brushType == brushType.ERASER) &&
                !(prevState.brushType == brushType.ERASER && this.state.brushType == brushType.BRUSH)) ||
            this.state.regions !== prevState.regions) && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.SELECTION_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let cache_buster_time = this.state.cacheBusterTime;
                let maskLocation = this.props.preview.response.maskLocation + "?d=" + cache_buster_time;
                let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
                if ((this.props.preview || {}).specimenType == specimenType.HNE_TISSUE) {
                    defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.IHC) {
                    defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.PAP) {
                    defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BM) {
                    defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
                }
                this.setState({
                    scanPathSet: false,
                });
                updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
                    this.thresholdCanvas, this.state.useDefaultMask ? defaultMaskLocation : maskLocation, this.state.regions, this.cleanupExtraCallback, true);
            }
            this.setState({
                previewStatus: newStatus,
            });
            // this.setState(Object.assign({}, this.state, {previewStatus : newStatus}));
        }
    }

    cleanupExtraCallback = () => {
        cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions[0]);
    }

    confirmClicked = () => {
        if (this.props.preview.status === RegionSelectionConstants.FETCHED_IMAGE) {
            this.props.dispatch(selectionDone(this.props.id));
        } else if (this.props.preview.status === RegionSelectionConstants.SELECTION_DONE) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            let reg = this.state.regions[0];
            let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
            let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2]
            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box, y1_box, x2_box, y2_box];
            this.props.dispatch(selectionConfirmed(this.props.deviceId, this.props.id, reg, actualReg,
                imageURLData, this.props.preview.slideName, this.props.startScanning, this.props.cassetteSize, this.props.preview.specimenType,
                this.props.preview.objectiveType, this.props.preview, this.dropDistanceCanvas, green_box_region));
        } else if (this.props.preview.status === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION) {
            this.props.dispatch(dropDistanceConfirmed(this.props.deviceId, this.props.id, this.props.preview, this.focusPointsCanvas));
        } else if (this.props.preview.status === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION) {
            this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        }
    }

    confirmPreviewSettingChanges = (queueForScan = null) => {
        this.props.onFinalizeSlideSettingsClick(); // show c240 to block UI
        // if (!this.state.scanPathSet) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            let reg = this.state.regions[0];
            let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
            let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2];
            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box, y1_box, x2_box, y2_box];
            this.props.dispatch(setDeviceBusy(this.props.deviceId));
            this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.CALCULATE_FOCUS_POINTS));
            let preview = this.props.preview;
            preview.scanningProfile = this.props.previewSlotOnly.scanningProfile
            const url = '/server/devices/' + this.props.deviceId + "/send_threshold_image/?slot_id=" + this.props.id+"&recalculate_path="+(!this.state.scanPathSet);
            const data = {
                imgBase64: imageURLData,
                specimenType: this.props.preview.specimenType,
                objectiveType: this.props.preview.objectiveType,
                actualRegion: actualReg,
                previewData: preview,
                greenBoxRegion: green_box_region,
            }
            post_response(url, data)
                .then(response => {
                    if (response.status === 200) {
                        this.props.dispatch(setPreviewStatusToConfirmed(this.props.id, reg, actualReg));
                        this.props.dispatch(setDropDistancePointOnly(this.props.id, response.data.dropDistancePoint));
                        this.props.dispatch(setDropDistancePointLength(this.props.id, response.data.dropDistancePoint));
                        this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
                        this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
                        this.setState({
                            scanPathSet: true,
                            currResponse: response,
                        });
                        if (!(this.props.cassetteSize === 1)) {
                            this.props.closeExpadedSlideView();
                        }
                        if(queueForScan != null){
                            queueForScan(this.props.id, false);
                        }
                    } else {
                        this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.id))
                        message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                    }
                    this.props.dispatch(getDeviceStatus(this.props.deviceId));
                    this.props.onFinalizedSlideSettings(); // remove c240 to enable UI
                    this.props.dispatch(setDeviceIdle(this.props.deviceId));
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                })
                .catch(err => {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.id))
                    this.props.dispatch(setDeviceIdle(this.props.deviceId));
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                    message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                    this.props.dispatch(getDeviceStatus(this.props.deviceId));
                    this.props.onFinalizedSlideSettings(); // remove c240 to enable UI
                })
        // } else {
        //     this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        //     if (!(this.props.cassetteSize === 1 || this.props.cassetteSize === 2)) {
        //         this.props.closeExpadedSlideView();
        //         this.props.dispatch(getDeviceStatus(this.props.deviceId));
        //         this.props.onFinalizedSlideSettings(); // remove c240 to enable UI
        //     }
        // }
    }

    cleanupExtraCallback = () => {
        cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions[0]);
    }

    paintCell = (x, y) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        if (this.state.brushShape === brushShape.SQUARE) {
            let cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
            thresholdContext.clearRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
            thresholdContext.fillStyle = this.state.brushType === brushType.BRUSH ? SlotRegionSelectionConstants.SELETION_FILL.RGBA : SlotRegionSelectionConstants.BLANK.RGBA;
            thresholdContext.fillRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
            let img = thresholdContext.getImageData(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);

            let affectedRegion = {
                startX: x - cellWidth / 2,
                startY: y - cellWidth / 2,
                endX: x + cellWidth / 2,
                endY: y + cellWidth / 2
            };
            img = cleanThresholdBorder(img, affectedRegion.startX, affectedRegion.startY, affectedRegion.endX, affectedRegion.endY);
            img = createBorderOnThresholdedCanvas(img, affectedRegion.startX - 1, affectedRegion.startY - 1, affectedRegion.endX + 1, affectedRegion.endY + 1);
            thresholdContext.putImageData(img, 0, 0);
        } else {
            const cellRadius = circleBrushSize[this.state.brushShape];

            thresholdContext.globalCompositeOperation = this.state.brushType === brushType.BRUSH ? 'xor' : 'source-over';
            thresholdContext.fillStyle = this.state.brushType === brushType.BRUSH ? SlotRegionSelectionConstants.SELETION_FILL.RGBA : SlotRegionSelectionConstants.BLANK.RGBA;
            if (this.state.brushType === brushType.BRUSH) {
                thresholdContext.beginPath();
                thresholdContext.arc(x, y, cellRadius, 0, 2 * Math.PI);
                thresholdContext.fill();
                thresholdContext.closePath();
            }

            let img = thresholdContext.getImageData(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);

            let affectedRegion = {
                startX: x - cellRadius,
                startY: y - cellRadius,
                endX: x + cellRadius,
                endY: y + cellRadius
            };
            img = createBorderOnThresholdedCanvas(img, affectedRegion.startX - 1, affectedRegion.startY - 1, affectedRegion.endX + 1, affectedRegion.endY + 1);
            thresholdContext.putImageData(img, 0, 0);
        }
    }

    showBrushOrEraserSize = (event) => {
        const cnvs = this.brushEraserPrevCanvas;
        if (cnvs != null) {
            const cnvsCtx = cnvs.getContext('2d');
            cnvsCtx.clearRect(0, 0, cnvs.width, cnvs.height);
            var rect = cnvs.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * cnvs.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * cnvs.height);
            if (this.state.brushShape === brushShape.SQUARE) {
                var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
                cnvsCtx.clearRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
                cnvsCtx.fillStyle = this.state.brushType === brushType.BRUSH ? "rgba(20,200,20,0.15)" : "rgba(200,20,20,0.15)";
                cnvsCtx.fillRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
                cnvsCtx.lineWidth = 1;
                cnvsCtx.strokeStyle = this.state.brushType === brushType.BRUSH ? "#22ee22" : "#EE2222";
                cnvsCtx.strokeRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
            } else {
                var cellRadius = circleBrushSize[this.state.brushShape];
                cnvsCtx.clearRect(mousex - cellRadius, mousey - cellRadius, cellRadius * 2, cellRadius * 2);
                cnvsCtx.fillStyle = this.state.brushType === brushType.BRUSH ? "rgba(20,200,20,0.15)" : "rgba(200,20,20,0.15)";
                cnvsCtx.beginPath();
                cnvsCtx.arc(mousex, mousey, cellRadius, 0, 2 * Math.PI);
                cnvsCtx.fill();
                cnvsCtx.lineWidth = 1;
                cnvsCtx.strokeStyle = this.state.brushType === brushType.BRUSH ? "#22ee22" : "#EE2222";
                cnvsCtx.stroke();
            }
        } else {
            console.warn("brush eraser preview canvas is null");
        }
    }

    paintCanvas = (event) => {
        if (this.paint) {
            var rect = this.thresholdCanvas.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * this.thresholdCanvas.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * this.thresholdCanvas.height);
            this.paintCell(mousex, mousey);

            // Clear any painting outside the region box
            cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas.getContext('2d'), this.state.regions[0]);
        }
        // show preview of current brush or eraser size
        this.showBrushOrEraserSize(event);
    }

    startPainting = (event) => {
        this.paint = true;
        this.paintCanvas(event);
        if (this.state.scanPathSet) {
            this.setState({
                scanPathSet: false,
            });
        }
    }

    stopPainting = () => this.paint = false;

    selectFullRegion = () => {
        this.setState(Object.assign({}, this.state, {
            regions: [
                {
                    data: {index: 0},
                    height: 100,
                    isChanging: false,
                    new: false,
                    width: 100,
                    x: 0,
                    y: 0,
                }
            ],
            oldState: RegionSelectionConstants.SELECTION_DONE
        }));
        this.confirmClicked();
    }

    toggleTiling = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingOnly(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingOnly(this.props.id));
        }
    }

    toggleTilingAfterScan = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingAfterScan(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingAfterScan(this.props.id));
        }
    }

    readbarcode = () => {
        this.setState({
            reading_barcode: true
        });
        let previewPath = this.props.preview.response.barcodeLocation;
        let url = `/server/devices/${this.props.deviceId}/read_barcode/?path=${previewPath}`;
        get(url).then(data => {
            if (data === "") {
                message.warn("No Barcode found on Slide. Please write Slide Name.")
            } else {
                this.props.dispatch(setScanName(this.props.id, data))
            }
            this.setState({
                reading_barcode: false
            });
        })
            .catch(err => {
                console.log(err);
            });
    }

    movedBrushSizeSlider = (value) => this.setState({brushSize: value});

    changeBrushType = (e) => {
        if (e.target.value === brushType.REDRAW) {
            this.setState({
                scanPathSet: false,
                useDefaultMask: true
            }, () => {
                const regions = this.defaultRegion.map(reg => Object.assign({}, reg));
                this.onCanvasUpdate(regions);
            });
        }
        if (e.target.value === brushType.ERASER && this.state.brushShape !== brushShape.SQUARE) {
            this.setState({
                brushShape: brushShape.SQUARE,
            });
        }
        this.setState({
            brushType: e.target.value,
        });
    }

    changeBrushShape = (brushShape) => {
        this.setState({
            brushShape: brushShape,
        });
    }

    previewCanvasRef = previewCanvas => this.previewCanvas = previewCanvas

    thresholdCanvasRef = thresholdCanvas => {
        this.thresholdCanvas = thresholdCanvas;
        this.updateGreenBox();
    }

    brushEraserPrevCanvasRef = brushEraserPrevCanvas => this.brushEraserPrevCanvas = brushEraserPrevCanvas;

    dropDistanceCanvasRef = dropDistanceCanvas => this.dropDistanceCanvas = dropDistanceCanvas;

    focusPointsCanvasRef = focusPointsCanvas => this.focusPointsCanvas = focusPointsCanvas;

    onScanSpeedChange = (event) => {
        this.props.dispatch(setScanSpeed(this.props.id, event.target.value));
        let newSpeed = event.target.value;
        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_scan_speed/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&scanSpeed=${newSpeed}`;

        get(url).then(res => {
            console.log("Scan speed successfully updated.")
        })
    }

    onScanSpeedChangeWSI = (newSpeed) => {
        this.props.dispatch(setScanSpeed(this.props.id, newSpeed));
        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_scan_speed/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&scanSpeed=${newSpeed}`;

        get(url).then(res => {
            console.log("Scan speed successfully updated.")
        })
    }

    onScanSpeedChangeStack = () => {
        this.props.dispatch(setScanSpeed(this.props.id, scanSpeed.ZSTACK));
        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_scan_speed/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&scanSpeed=${scanSpeed.ZSTACK}`;

        get(url).then(res => {
            console.log("Scan speed successfully updated to ZSTACK.")
        })
    }

    onZLevelsChange = (event) => {
        let newZLevel = event.target.value
        this.props.dispatch(setScanZLevels(this.props.id, newZLevel));
        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_zstack_level/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&zstackLevel=${newZLevel}`;

        get(url).then(res => {
            console.log("Z Level successfully updated to ZSTACK.")
        })
    }

    onStepSizeChange = (event) => {
        let newZStep = event.target.value
        this.props.dispatch(setScanZStepSize(this.props.id, newZStep));
        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_zstack_step/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&zstackStep=${newZStep}`;

        get(url).then(res => {
            console.log("Step Size successfully updated to ZSTACK.")
        })
    }

    onSpecimenTypeChange = (event) => {
        const newSpecimenType = event.target.value;
        this.props.dispatch(setSpecimenType(this.props.id, newSpecimenType));

        if (this.state.scan_type === scanTypeVals.BLOOD && newSpecimenType !== specimenType.BM) {
            this.onScanTypeChange(scanTypeVals.WSI)
        }

        let rack_tray = this.getRackAndTray();
        let url = `/server/devices/${this.props.deviceId}/set_specimen_type/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&specimenType=${newSpecimenType}`;
        get(url).then(res => {
            console.log("specimen type updated")
        })
        let cache_buster_time = this.state.cacheBusterTime;
        let maskLocation = this.props.preview.response.maskLocation + "?d=" + cache_buster_time;
        let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
        if (event.target.value == specimenType.HNE_TISSUE) {
            defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.IHC) {
            defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.PAP) {
            defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.BM) {
            defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.BLOOD) {
            defaultMaskLocation = this.props.preview.response.defaultBloodMaskLocation + "?d=" + cache_buster_time;
        }
        updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
            this.thresholdCanvas, this.state.useDefaultMask ? defaultMaskLocation : maskLocation, this.state.regions, this.cleanupExtraCallback, true);

        this.setState({
            scanPathSet: false,
        });
    }

    onAutoThreshLevelChange = (value) => {
		this.props.dispatch(setAutoThreshLevel(this.props.id, value));
        this.setState({autoThresholdLevel: value})

		let cache_buster_time = this.state.cacheBusterTime;
		let defaultMaskLocation = this.props.preview.response.autoThreshMaskLocations[value] + "?d=" +  cache_buster_time;
		updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
			this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback, true);
		
		this.setState({
			scanPathSet: false,
		});
	}


    getRackAndTray = () => {
        let key = this.props.cassetteKey;
        let rack = parseInt(key.split("T")[0].split("R")[1]);
        let tray = parseInt(key.split("T")[1]);
        return [rack, tray];
    }

    onScanNameChange = (event) => {
        let slide_name = event.target.value;

        let folderNameSplit = slide_name.split("-")
        if (folderNameSplit.length > 1) {
            this.onFolderNameChange(folderNameSplit[0] + "-" + folderNameSplit[1]);
        } else {
            this.onFolderNameChange(folderNameSplit[0]);
        }

        let rack_tray = this.getRackAndTray();
        this.props.dispatch(setScanName(this.props.id, slide_name))
        let url = `/server/devices/${this.props.deviceId}/set_slide_name_v2/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&slideName=${slide_name}`;
        get(url).then(res => {
            console.log("name updated")
        })
    }

    onFolderNameChange = (folderName) => {
        let rack_tray = this.getRackAndTray();
        this.props.dispatch(setFolderName(this.props.id, folderName))
        if (folderName === undefined || folderName === "undefined") {
            folderName = "";
        }
        let url = `/server/devices/${this.props.deviceId}/set_folder_name_v2/?slotID=${this.props.id}&rack=` +
            `${rack_tray[0]}&tray=${rack_tray[1]}&folderName=${folderName}`;
        get(url).then(res => {
            console.log("name updated")
        })
    }

    onWBCCountChange = (numWBCToScan) => {
        let rack_tray = this.getRackAndTray();
        this.setState({
            wbcCount: numWBCToScan
        })

        let url = `/server/devices/${this.props.deviceId}/set_wbc_count/?slotID=${this.props.id}&rack=${rack_tray[0]}&tray=${rack_tray[1]}&numWBCToScan=${numWBCToScan}`;
        get(url).then(res => {
            console.log("WBC updated")
        })
    }

    onScanTypeChange = (key) => {
        if (key !== scanTypeVals.BLOOD) {
            this.onWBCCountChange(-1);
            if (key === scanTypeVals.Z_STACK) {
                this.onScanSpeedChangeStack();
            } else if (key === scanTypeVals.WSI) {
                this.onScanSpeedChangeWSI(scanSpeed.MEDIUM);
            }
        } else {
            this.onWBCCountChange(100);
        }

        this.setState({
            scan_type: key,
        });
    }

    changeScanSettingsType = (key) => {
        if (key == scanSettingsTypeVals.ADVANCED) {
            if (!this.state.scanPathSet) {
                let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
                let reg = this.state.regions[0];
                let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
                let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
                let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
                let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
                let actualReg = [x1, y1, x2, y2];
                let thresholdCanvas = this.thresholdCanvas;
                let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
                let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
                let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
                let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
                let green_box_region = [x1_box, y1_box, x2_box, y2_box];
                this.props.dispatch(setDeviceBusy(this.props.deviceId));
                this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.CALCULATE_FOCUS_POINTS));
                let preview = this.props.preview;
                preview.scanningProfile = this.props.previewSlotOnly.scanningProfile
                const url = '/server/devices/' + this.props.deviceId + "/send_threshold_image/?slot_id=" + this.props.id+"&recalculate_path="+(!this.state.scanPathSet);
                const data = {
                    imgBase64: imageURLData,
                    specimenType: this.props.preview.specimenType,
                    objectiveType: this.props.preview.objectiveType,
                    actualRegion: actualReg,
                    previewData: preview,
                    greenBoxRegion: green_box_region,
                }
                post_response(url, data)
                    .then(response => {
                        if (response.status === 200) {
                            this.props.dispatch(setPreviewStatusToConfirmed(this.props.id, reg, actualReg));
                            this.props.dispatch(setDropDistancePointOnly(this.props.id, response.data.dropDistancePoint));
                            this.props.dispatch(setDropDistancePointLength(this.props.id, response.data.dropDistancePoint));
                            this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
                            this.setState({
                                scanSettingsType: key,
                                scanPathSet: true,
                                currResponse: response,
                            });
                        } else {
                            this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.id));
                            message.error("Not able to switch to advanced settings. Please contact admin.", 2.5);
                        }
                        this.props.dispatch(setDeviceIdle(this.props.deviceId));
                        this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                    })
                    .catch(err => {
                        this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.id))
                        this.props.dispatch(setDeviceIdle(this.props.deviceId));
                        this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                        message.error("Not able to switch to advanced settings. Please contact admin.", 2.5);
                    })
            } else {
                this.setState({
                    scanSettingsType: key,
                });
            }
        } else if (key == scanSettingsTypeVals.GENERAL) {
            this.setState({
                scanSettingsType: key,
            });
        }
    }

    render() {
        let status = (this.props.preview || {}).status;
        let allowPainting = false;
        let slotComp = null;

        if (this.state.brushType != brushType.REDRAW) {
            allowPainting = true;
        }

        if (this.props.showSummary) {
            slotComp = this.props.summaryDiv;
        } else if (this.props.id === -1 || status === RegionSelectionConstants.NOT_STARTED) {
        } else if (status !== RegionSelectionConstants.ERRORED_OUT) {
            const menu = (
                <Menu className="black-rounded-button">
                    <Menu.Item className="black-rounded-button">
                        <Button className="black-rounded-button"
                                onClick={() => {this.confirmPreviewSettingChanges()}} style={{fontSize: 16}}>
                            Finalize Settings
                        </Button>
                    </Menu.Item>
                </Menu>
            )
            slotComp = (
                <div className="full-parent" >
                    <Row className={"full-width"} style={{height: "825px", display: "flex", marginLeft : "20px"}}>
                    <Tabs className="c240-tab-section-height full-parent" activeKey={this.state.scanSettingsType}
                          onChange={this.changeScanSettingsType}>
                        <TabPane tab="Settings" key={scanSettingsTypeVals.GENERAL} className="c240-black full-parent">
                            <GeneralPreviewSettingsComp showBrushOrEraserSize={this.showBrushOrEraserSize}
                                                        brushType={this.state.brushType}
                                                        brushSize={this.state.brushSize}
                                                        changeBrushType={this.changeBrushType}
                                                        movedBrushSizeSlider={this.movedBrushSizeSlider} status={status}
                                                        previewCanvasRef={this.previewCanvasRef}
                                                        thresholdCanvasRef={this.thresholdCanvasRef}
                                                        brushEraserPrevCanvasRef={this.brushEraserPrevCanvasRef}
                                                        regions={this.state.regions}
                                                        onCanvasUpdate={this.onCanvasUpdate}
                                                        allowPainting={allowPainting} startPainting={this.startPainting}
                                                        paintCanvas={this.paintCanvas}
                                                        stopPainting={this.stopPainting}
                                                        dropDistanceCanvas={this.dropDistanceCanvas}
                                                        dropDistanceCanvasRef={this.dropDistanceCanvasRef}
                                                        focusPointsCanvas={this.focusPointsCanvas}
                                                        focusPointsCanvasRef={this.focusPointsCanvasRef}
                                                        id={this.props.id} deviceId={this.props.deviceId}
                                                        onScanNameChange={this.onScanNameChange}
                                                        readbarcode={this.readbarcode}
                                                        reading_barcode={this.state.reading_barcode}
                                                        onSpecimenTypeChange={this.onSpecimenTypeChange}
                                                        onScanSpeedChange={this.onScanSpeedChange}
                                                        onScanSpeedChangeStack={this.onScanSpeedChangeStack}
                                                        onZLevelsChange={this.onZLevelsChange}
                                                        onStepSizeChange={this.onStepSizeChange}
                                                        toggleTiling={this.toggleTiling}
                                                        toggleTilingAfterScan={this.toggleTilingAfterScan}
                                                        onWBCCountChange={this.onWBCCountChange}
                                                        regionArea={this.state.regionArea}
                                                        onScanTypeChange={this.onScanTypeChange}
                                                        preview={this.props.preview}
                                                        cassetteKey={this.props.cassetteKey}
                                                        wbcCount={this.state.wbcCount}
                                                        slideType={this.props.slideType}
                                                        autoThresholdLevel={this.state.autoThresholdLevel}
                                                        onAutoThreshLevelChange={this.onAutoThreshLevelChange}
                                                        onFolderNameChange={this.onFolderNameChange}
                                                        brushShape={this.state.brushShape}
                                                        changeBrushShape={this.changeBrushShape}
                                                        scan_type={this.state.scan_type}/>
                        </TabPane>
                        <TabPane tab="Advanced" key={scanSettingsTypeVals.ADVANCED}>
                            <AdvancedPreviewSettingsComp
                                id={this.props.id}
                                deviceId={this.props.deviceId}
                                scanSettingsType={this.state.scanSettingsType}
                                preview={this.props.preview}
                                currResponse={this.state.currResponse}
                                casetteKey={this.props.cassetteKey}/>
                        </TabPane>
                    </Tabs>
                    </Row>
                    <Row style={{display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "5%"}}>
                        <Button size="large" className="black-rounded-button" style={{width: '35%', marginRight: '20px'}} onClick={this.props.closeExpadedSlideView}>
                            {/*<Icon type="left-circle" theme="filled" /> */}
                            Go Back
                        </Button>
                        {/*<Dropdown overlay={menu}>*/}
                            <Button size="large" className="black-rounded-button" style={{width: '35%'}}
                                    onClick={() => {this.confirmPreviewSettingChanges(this.props.queueForScan)}}>
                                {"Finalize and Add Scan to Queue"}
                                {/*<Icon type="down" />*/}
                            </Button>
                        {/*</Dropdown>*/}
                    </Row>
                </div>
            )
        } else {
            slotComp = <Row>Error</Row>;
        }

        // FIXME: remove hardcoded spinning and tip was tip={this.props.preview.message}
        return (
            <Spin spinning={this.props.previewSlotOnly.status === RegionSelectionConstants.GETTING_IMAGE || this.props.previewSlotOnly.actionOngoing}
                  tip={this.props.previewSlotOnly.message}
                  wrapperClassName={'full-parent'}>
                {slotComp}
            </Spin>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        deviceStatus: state.deviceStatusReducer,
        previewSlotOnly: state.previewStatusReducer[ownProps.id],
    };
};

export default connect(mapStateToProps)(SlideAreaSelectionComponent);
